import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  type AbuseEventsRequest,
  type AbuseSubjectKey,
  type AbuseSubjectsRequest,
  type AbuseTimeRange,
  getAbuseEvents,
  getAbuseSubject,
  getAbuseSubjects,
  getAbuseSummary,
  mapEventsResponse,
  mapSubjectDetail,
  mapSubjectsResponse,
} from '@/services/api/abuse';

export const ABUSE_QUERY_KEY = ['compliance', 'abuse'] as const;

export const abuseSummaryQueryOptions = (range: AbuseTimeRange) =>
  queryOptions({
    queryKey: [...ABUSE_QUERY_KEY, 'summary', range],
    queryFn: ({ signal }) => getAbuseSummary(range, signal),
  });

export const abuseEventsQueryOptions = (request: AbuseEventsRequest) =>
  queryOptions({
    queryKey: [...ABUSE_QUERY_KEY, 'events', request],
    queryFn: ({ signal }) => getAbuseEvents(request, signal),
    select: mapEventsResponse,
  });

export const abuseSubjectsQueryOptions = (request: AbuseSubjectsRequest) =>
  queryOptions({
    queryKey: [...ABUSE_QUERY_KEY, 'subjects', request],
    queryFn: ({ signal }) => getAbuseSubjects(request, signal),
    select: mapSubjectsResponse,
  });

export const abuseSubjectQueryOptions = (key: AbuseSubjectKey, range?: AbuseTimeRange) =>
  queryOptions({
    queryKey: [...ABUSE_QUERY_KEY, 'subject', key.subjectType, key.subjectId, range ?? 'default'],
    queryFn: ({ signal }) => getAbuseSubject(key, range, signal),
    select: mapSubjectDetail,
  });

export const useAbuseSummary = (range: AbuseTimeRange, enabled = true) => useQuery({ ...abuseSummaryQueryOptions(range), enabled });

export const useAbuseEvents = (request: AbuseEventsRequest) => useQuery(abuseEventsQueryOptions(request));

export const useAbuseSubjects = (request: AbuseSubjectsRequest) => useQuery(abuseSubjectsQueryOptions(request));

export const useAbuseSubject = (key: AbuseSubjectKey, range?: AbuseTimeRange) => useQuery(abuseSubjectQueryOptions(key, range));
